// extracted by mini-css-extract-plugin
export default {"container":"container__M3l8y","main":"main__TXbiJ","page-title":"page-title__X9MFp","icon":"icon__YBFgR"};